var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456",
    transform: "translate(-0.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1976",
    "data-name": "Rectangle 1976",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(0.074)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(12.074 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67642",
    "data-name": "Path 67642",
    d: "M25.152,12.649A12.586,12.586,0,0,1,14.536,25.073V16.309h2.923l.556-3.626H14.536V10.33a1.813,1.813,0,0,1,2.044-1.959h1.581V5.284a19.275,19.275,0,0,0-2.808-.245c-2.865,0-4.737,1.737-4.737,4.879v2.764H7.431v3.626h3.185v8.764A12.576,12.576,0,1,1,25.152,12.649Z",
    transform: "translate(0 -0.073)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4b380644808df92aa97055af4aeaa811.svg";
export { ForwardRef as ReactComponent };